import React from 'react';
import { TechnicalSheetViewer } from './TechnicalSheetViewer';

export const ProductTechnicalDetails = ({ product }) => {
  const details = product.technicalDetails;
  if (!details) return null;
  return <section className="mt-12 sm:mt-16 pt-10 border-t border-gray-200" data-testid="product-technical-details">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
      <div className="min-w-0">
        <h2 className="text-base md:text-lg font-semibold mb-5" data-testid="technical-specifications-heading">Tehnički podaci</h2>
        <dl className="divide-y divide-gray-200" data-testid="technical-specifications">
          <div className="grid grid-cols-2 gap-4 py-4 text-sm">
            <dt className="text-gray-500">Šifra artikla</dt>
            <dd className="font-medium break-words" data-testid="technical-product-sku">{product.sku}</dd>
          </div>
          {details.specifications.map(row => <div key={row.key} className="grid grid-cols-2 gap-4 py-4 text-sm" data-testid={`technical-row-${row.key}`}>
            <dt className="text-gray-500 break-words" data-testid={`technical-label-${row.key}`}>{row.label}</dt>
            <dd className="font-medium break-words min-w-0" data-testid={`technical-value-${row.key}`}>{row.value}</dd>
          </div>)}
        </dl>
        <p className="mt-6 text-xs text-gray-500" data-testid="technical-specifications-source">Izvor: {details.sourceName}, str. {details.printedPage}.</p>
      </div>
      <TechnicalSheetViewer details={details} sku={product.sku} />
    </div>
  </section>;
};